<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
    <div class="container">
        <h1>Gestão de pagamentos solicitados (retiradas)</h1>

        <div class="subheader">
            <span class="total">Total: <strong>{{ total }}</strong></span>
        </div>

        <ng-container *ngIf="isLoading; else listTpl">
            <div class="spinner">
                <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
            </div>
        </ng-container>

        <ng-template #listTpl>
            <!-- Cabeçalho -->
            <div class="list-header">
                <div class="col">Solicitação</div>
                <div class="col">Usuário</div>
                <div class="col">Valores / Datas</div>
                <div class="col">Status</div>
                <div class="col actions">Ações</div>
            </div>

            <!-- Linhas -->
            <div class="row" *ngFor="let it of list; trackBy: trackById">
                <!-- Solicitação -->
                <div class="col">
                    <div class="mono strong">#{{ it.idWalletWithdrawal }}</div>
                </div>

                <!-- Usuário -->
                <div class="col">
                    <div class="title">{{ it.userName || ('Usuário ' + it.idUser) }}</div>
                    <div class="sub mono" *ngIf="it.userProcessorName || it.idUserProcessor">
                        Processado por: {{ it.userProcessorName || it.idUserProcessor }}
                    </div>
                    <div class="sub mono" *ngIf="it.processedAt"><strong>em </strong> {{ it.processedAt | date:'dd/MM/yyyy HH:mm' }}</div>
                </div>

                <!-- Valores / Datas -->
                <div class="col">
                    <div><strong>Valor:</strong> {{ it.amount | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</div>
                    <div><strong>PIX:</strong> {{ it.pix }}</div>
                    <div class="sub mono"><strong>Solicitado em:</strong> {{ it.requestedAt | date:'dd/MM/yyyy HH:mm' }}</div>
                </div>

                <!-- Status -->
                <div class="col">
                    <span class="chip" [ngClass]="statusClass(it)">
                        {{ statusText(it) }}
                    </span>
                </div>

                <!-- Ações -->
                <!-- Ações -->
                <div class="col actions">
                    <div class="actions-inner">

                        <!-- Comprovante: se não tem, permite anexar + confirmar pagamento (irreversível) -->
                        <div class="bubble" *ngIf="!it.receipt && !it.processedAt; else receiptActions">
                            <button style="width:auto" mat-icon-button
                                matTooltip="Anexar comprovante e confirmar pagamento (irreversível)"
                                (click)="receiptInput.click()">
                                <span style="font-size:12px;border-radius:0">Anexar comprovante</span>
                            </button>

                            <!-- MESMO nome em cada linha; o ngFor cria escopos separados -->
                            <input #receiptInput type="file" accept="image/*,application/pdf" class="hidden"
                                (change)="onSelectReceipt(it, $event)">
                        </div>

                        <!-- Se tem comprovante: permite baixar/abrir -->
                        <ng-template #receiptActions>
                            <div class="bubble">
                                <a *ngIf="it.receipt" [href]="it.receipt" download mat-icon-button
                                    matTooltip="Baixar comprovante">
                                    <mat-icon>download</mat-icon>
                                </a>
                            </div>
                        </ng-template>

                    </div>
                </div>
            </div>

            <div *ngIf="!list?.length" class="empty">
                Nenhuma retirada solicitada encontrada.
            </div>
        </ng-template>
    </div>
</div>

<app-footer></app-footer>